import { defineStore } from 'pinia'
import { ref } from 'vue'
import { data4seoService } from '../services/data4seo'

export const useLocationStore = defineStore('location', () => {
  const locations = ref([])
  const selectedLocation = ref(null)
  const loading = ref(false)
  const error = ref(null)

  async function fetchLocations() {
    if (locations.value.length > 0) return

    loading.value = true
    error.value = null
    
    try {
      const data = await data4seoService.getLocations()
      locations.value = data
      
      // Set default location to United States if available
      const defaultLocation = data.find(loc => loc.country_iso_code === 'US' && loc.is_country)
      if (defaultLocation && !selectedLocation.value) {
        selectedLocation.value = defaultLocation
      }
    } catch (err) {
      console.error('Error fetching locations:', err)
      error.value = err.message
    } finally {
      loading.value = false
    }
  }

  function setSelectedLocation(location) {
    selectedLocation.value = location
  }

  return {
    locations,
    selectedLocation,
    loading,
    error,
    fetchLocations,
    setSelectedLocation
  }
})
